export enum QueueType {
  supervisor = 1,
  identification = 2,
  dataEntry = 3,
  caseManagement = 4
}
